import React, { useState } from 'react'
import { useAuth } from '@templatean/shared/hooks'
import { LoginRequest } from '@templatean/shared/types'
import { validators } from '@templatean/shared/utils'

const LoginPage: React.FC = () => {
  const { login, isLoading, error } = useAuth()
  const [credentials, setCredentials] = useState<LoginRequest>({
    email: '',
    password: ''
  })
  const [validationErrors, setValidationErrors] = useState<Record<string, string>>({})

  const validateForm = (): boolean => {
    const errors: Record<string, string> = {}
    
    if (!credentials.email) {
      errors.email = 'Email is required'
    } else if (!validators.email(credentials.email)) {
      errors.email = 'Invalid email address'
    }
    
    if (!credentials.password) {
      errors.password = 'Password is required'
    }
    
    setValidationErrors(errors)
    return Object.keys(errors).length === 0
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    
    if (!validateForm()) return
    
    try {
      await login(credentials)
    } catch (err) {
      console.error('Login failed:', err)
    }
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <h1>Templatean for PowerPoint</h1>
          <p>Sign in to create amazing presentations with AI</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={credentials.email}
              onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
              placeholder="Enter your email"
              className={`form-input ${validationErrors.email ? 'error' : ''}`}
            />
            {validationErrors.email && (
              <span className="error-message">{validationErrors.email}</span>
            )}
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={credentials.password}
              onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
              placeholder="Enter your password"
              className={`form-input ${validationErrors.password ? 'error' : ''}`}
            />
            {validationErrors.password && (
              <span className="error-message">{validationErrors.password}</span>
            )}
          </div>
          
          {error && (
            <div className="alert alert-error">{error}</div>
          )}
          
          <button
            type="submit"
            disabled={isLoading}
            className="btn btn-primary btn-block"
          >
            {isLoading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        
        <div className="login-footer">
          <a href="#" className="link">Forgot password?</a>
          <span className="separator">•</span>
          <a href="#" className="link">Create account</a>
        </div>
      </div>
    </div>
  )
}

export default LoginPage